import React from 'react'

import ReactDOM from 'react-dom'

import {AppContainer} from 'react-hot-loader'

import { Provider } from 'react-redux';
import configureStore from './store/configureStore';

import App from './App'


const store = configureStore();

const render = (Component) => {
    ReactDOM.render(
        <Provider store={store}>
            <AppContainer>
                <Component/>
            </AppContainer>
        </Provider>,
        document.getElementById('root'),
    )
};

render(App);
if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./App', () => {
        render(App)
    })
}



// WEBPACK FOOTER //
// ./src/index.js